import _ from 'lodash'
import Pager from './Pager'
import Total from './Total'
import SizeChanger from './SizeChanger'
import Jumper from './Jumper'

export default {
  name: 'KPagination',
  provide() {
    return {
      context: this,
    }
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 总记录数
    total: {
      type: Number,
      required: true,
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
    // 默认页码
    defaultCurrent: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    pageSizeOptions: {
      type: Array,
      // 20/ 50/ 100
      default() {
        return [20, 50, 100]
      },
    },
    showSizeChanger: {
      type: Boolean,
      default: false,
    },
    showJumper: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    // 当前页码数
    value: {
      type: Number,
      default: 1,
    },
    // 包含首页码（1） 和 尾页码
    pagerCount: {
      type: Number,
      default: 7,
    },
  },
  data() {
    return {
      current: 1,
      innerPageSize: this.pageSize,
    }
  },
  computed: {
    totalPage() {
      const { total, innerPageSize } = this
      return Math.ceil(total / innerPageSize)
    },
  },
  watch: {
    // total: {
    //   immediate: true,
    //   handler(value) {
    //     if (value < 1) {
    //       this.current = 0
    //     } else {
    //       // this.current = 1
    //     }
    //   },
    // },
    pageSize: {
      immediate: true,
      handler() {
        if (this.pageSizeOptions.indexOf(this.pageSize) === -1 && this.showSizeChanger === true) {
          this.innerPageSize = this.pageSizeOptions[0]
        } else {
          this.innerPageSize = this.pageSize
        }
      },
    },
    innerPageSize() {
      this.current = 1
      this.handlePageSizeChange()
    },
    value() {
      this.current = this.value
    },
    current() {
      this.$emit('input', this.current)
      this.handlePageChange()
    },
  },
  created() {
    this.current = this.value || this.defaultCurrent || 1
  },
  methods: {
    handlePageChange: _.debounce(function () {
      this.$emit('change', {
        current: this.current,
        pageSize: this.innerPageSize,
      })
    }, 200),
    handlePageSizeChange: _.debounce(function () {
      this.$emit('page-size-change', {
        pageSize: this.innerPageSize,
      })
    }, 200),
  },
  render() {
    return (
      <div
        class={{
          'km-pagination': true,
          'km-pagination--disabled': this.disabled,
          'km-pagination--small': this.small,
        }}

      >

        {this.showTotal ? <Total>{this.$scopedSlots.total}</Total> : null}

        {
          this.showSizeChanger ? (
            this.$scopedSlots.sizeChanger ? (
              this.$scopedSlots.sizeChanger({
                pageSizeOptions: this.pageSizeOptions,
              })
            ) : (
              <SizeChanger />
            )
          ) : null
        }

        <Pager />

        {this.showJumper ? <Jumper /> : null}

      </div>
    )
  },
}
